import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const ScrollToTop = () => {
  const location = useLocation();

  useEffect(() => {
    // Immediate scroll for browsers without smooth scroll
    window.scrollTo(0, 0);
    
    // Also scroll the body element
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
    
    // Small delay to ensure Lenis is ready
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: 'auto' });
    }, 0);
  }, [location.pathname, location.key]);

  return null;
};
